import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const isAny = (
  inputObservables: Observable<boolean | null>[],
  condition: (input: boolean | null) => boolean
) => {
  return combineLatest(inputObservables).pipe(
    map(value => {
      return value.some(condition);
    })
  );
};
